import { render, staticRenderFns } from "./LocationServiceTimeForm.vue?vue&type=template&id=5bb1ca93&scoped=true&"
import script from "./LocationServiceTimeForm.vue?vue&type=script&lang=js&"
export * from "./LocationServiceTimeForm.vue?vue&type=script&lang=js&"
import style0 from "./LocationServiceTimeForm.vue?vue&type=style&index=0&id=5bb1ca93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb1ca93",
  null
  
)

export default component.exports